module.exports = __webpack_public_path__ + "img/logo_nobunaga.4879ad9d.png";